import { noop as noopLodash } from "lodash-es";

/** A no-operation (noop) function that does nothing.
 * Can be used as a default callback or placeholder for unused function props.
 */
export const noop = noopLodash;
